import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
	createStyles({
		large: {
			width: theme.spacing(5),
			height: theme.spacing(5),
		},
		gridNotificationRow: {
			[theme.breakpoints.down('sm')]: {
				paddingTop: 0,
				paddingRight: 0,
				marginTop: 2,
			},
			paddingTop: 7,
			paddingRight: 5,
		},
		avatarColor: {
			color: theme.palette.getContrastText(theme.palette.secondary.dark),
			backgroundColor: theme.palette.secondary.dark,
		},
		nameWhenSmall: {
			[theme.breakpoints.down('sm')]: {
				display: 'block',
				fontSize: '80%',
				width: 50,
				//border: '1px solid red',
				textAlign: 'right',
			},
		},
		avatarWhenSmall: {
			[theme.breakpoints.down('sm')]: {
				float: 'right',
				margin: 0,
				marginTop: 5,
				padding: 0,
			},
		},
	})
);
